module.exports = __webpack_public_path__ + "img/162.c8fa807b.jpg";